import { Text } from '@dixa/lib-shared-habla';
import type { PropsWithClassName } from 'lib-shared-types-utils';
import Dropzone from 'react-dropzone';


import styles from './uploadDropzone.module.scss';

type UploadDropzoneProps = PropsWithClassName & {
  disabled?: boolean;
  dropzoneText?: string;
  onDrop: (file: File) => void;
  onReject: (file: File, reason: 'size' | 'type') => void;
  maxFileSize: number;
  allowedFileTypes: string;
};

export const UploadDropzone = ({
  disabled,
  onDrop,
  onReject,
  dropzoneText,
  className,
  maxFileSize,
  allowedFileTypes,
}: UploadDropzoneProps): JSX.Element => {
  const handleOnDrop = (acceptedFiles: File[], rejectedFiles: File[]): void => {
    if (disabled) {
      return;
    }
    if (acceptedFiles.length > 0) {
      onDrop(acceptedFiles[0]);
    } else if (rejectedFiles.length > 0) {
      if (maxFileSize <= rejectedFiles[0].size) {
        onReject(rejectedFiles[0], 'size');
      } else {
        onReject(rejectedFiles[0], 'type');
      }
    }
  };

  return (
    <Dropzone
      onDrop={handleOnDrop}
      accept={allowedFileTypes}
      multiple={false}
      className={className || styles.dropzone}
      maxSize={maxFileSize}
      disableClick={disabled}
    >
      {dropzoneText && <Text.Paragraph>{dropzoneText}</Text.Paragraph>}
    </Dropzone>
  );
};
